export enum OutgoingPages {
	OrderActions = '/tabs/outgoing/order/:orderId/actions',
	ChangeTime = '/tabs/outgoing/order/:orderId/changeTime',
	Scanner = '/tabs/outgoing/order/scanner',
	OrderDetail = '/tabs/outgoing/order/:orderId/detail',
	ScanTotes = '/tabs/outgoing/order/:orderId/totes-scanner',
	Helpdesk = '/tabs/outgoing/order/:orderId/helpdesk',
	Refund = '/tabs/outgoing/order/:orderId/refund',
}
